import { useState } from "react";
import { Button } from "@narmi/design_system";

const CopyableCell = ({
  title,
  copyText,
  text,
  truncateLength,
  style,
  buttonSize = "m",
}: {
  title?: string;
  copyText?: string;
  text: string;
  truncateLength?: number;
  style?: React.CSSProperties;
  buttonSize?: "m" | "s" | "xs";
}) => {
  const [showCopied, setShowCopied] = useState(false);

  function clicked() {
    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 600);
  }

  const displayText = truncateLength ? `${text?.substring(0, truncateLength)}...` : text;

  return (
    <div className="copyable-cell">
      <span>{title ? `${title}: ` : ""}</span>
      <Button
        kind="plain"
        type="button"
        style={style || { cursor: "pointer", color: "var(--color-black)" }}
        onClick={(e: Event) => {
          navigator.clipboard.writeText(copyText || text);
          clicked();
          e.stopPropagation();
        }}
        label={showCopied ? "Copied..." : displayText}
        endIcon="copy"
        size={buttonSize}
      />
    </div>
  );
};

export default CopyableCell;
